import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const C = () => {
  return (
    <StartInterviewLayout type="c"/>
  )
}

export default C;